import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Table, Modal, Button, Form, ProgressBar } from 'react-bootstrap';
import { FaPlus, FaTimes, FaEdit, FaTrash, FaSortAmountUp, FaSortAmountDown, FaChevronDown, FaCog, FaFileImport, FaSearch, FaTools, FaQuestionCircle, FaRegQuestionCircle, FaArrowRight, FaArrowLeft, FaTrashAlt, FaSignLanguage, FaFileExport, FaTags } from 'react-icons/fa';
import Navbar from '../../dashboard/navbar';
import { useLocation, useNavigate } from 'react-router-dom';
import Sidebar from '../../dashboard/sidebar'
import useAuth from '../../dashboard/useAuth';
import axios from 'axios';
import Select from "react-select";
import { Dropdown, ButtonGroup } from "react-bootstrap";

const Liste_qcm = ({ titre }) => {
    useAuth();
    const existingAcces = { acces: [] };

    // États principaux
    const [currentLangue, setCurrentLangue] = useState('fr'); // 'fr' ou 'en'
    const [qcms, setQcms] = useState([]);
    const [qcmsDefaillant, setQcmsDefaillant] = useState();
    const [selectedQcm, setSelectedQcm] = useState(null);
    const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'ascending' });
    const [searchTerm, setSearchTerm] = useState('');
    const [showModalTag, setAfficherModalTag] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showImportModal, setShowImportModal] = useState(false);
    const [showExportModal, setShowExportModal] = useState(false);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingRecherche, setIsLoadingRecherche] = useState(false);
    const [isLoadingDefaillant, setIsLoadingDefaillant] = useState(false);
    const [tableAVider, setTableAVider] = useState("toutes");


    const [isSearchMode, setIsSearchMode] = useState(false);
    const [searchParams, setSearchParams] = useState({});

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const [hasMore, setHasMore] = useState(true);

    const location = useLocation();
    const user_id = localStorage.getItem('user_id');
    const navigate = useNavigate();

    // Autres états et configurations
    const restrictions = [
        { value: "Simulateur", label: "Simulateur" },
        { value: "Examen_blanc", label: "Examen blanc" },
        { value: "Evaluation", label: "Evaluation" },
        { value: "Etude_de_cas", label: "Etude de cas" },
    ];

    const options = [
        { value: "A", label: "A" },
        { value: "B", label: "B" },
        { value: "C", label: "C" },
        { value: "D", label: "D" },
        { value: "E", label: "E" },
        { value: "F", label: "F" },
    ];

    const [showColumnSelector, setShowColumnSelector] = useState(false);
    const columnLabels = {
        id: "Identifiant",
        ref: "Référence",
        question: "Question",
        option1: "Option 1",
        option2: "Option 2",
        option3: "Option 3",
        option4: "Option 4",
        option5: "Option 5",
        option6: "Option 6",
        reponse: "Réponse",
        eco: "Eco",
        domaine_connaissance: "Domaine de connaissance",
        groupe_processus: "Groupe de processus",
        approche: "Approche",
        niveau: "Niveau",
        source: "Source",
        tag: "Tag",
        situation: "Mise en situation", // Nouveau champ
    };

    const [visibleColumns, setVisibleColumns] = useState({
        id: true,
        ref: true,
        question: true,
        option1: false,
        option2: false,
        option3: false,
        option4: false,
        option5: false,
        option6: false,
        reponse: false,
        eco: false,
        domaine_connaissance: true,
        groupe_processus: true,
        approche: false,
        niveau: false,
        source: false,
        tag: true,
        situation: true, // Nouveau champ visible par défaut
    });

    // Références et états pour l'affichage
    const [expandedQuestions, setExpandedQuestions] = useState({});
    const [questionOverflows, setQuestionOverflows] = useState({});
    const questionRefs = useRef({});
    const dropdownRef = useRef(null);

    // Données supplémentaires
    const [domaines, setDomaines] = useState([]);
    const [ecos, setEcos] = useState([]);
    const [groupeprocessus, setGroupeProcessus] = useState([]);
    const [tags, setTags] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [progress, setProgress] = useState(0);
    const [isImporting, setIsImporting] = useState(false);
    const [exportFields, setExportFields] = useState({ db: "fr", tag: "" });
    const [isLoadingBouton, setIsLoadingBouton] = useState(false);

    // Recherche avancée (non modifiée)
    const [showAdvancedSearchModal, setShowAdvancedSearchModal] = useState(false);
    const [advancedSearchFields, setAdvancedSearchFields] = useState({
        id: '',
        ref: '',
        question: '',
        option1: '',
        option2: '',
        option3: '',
        option4: '',
        option5: '',
        option6: '',
        reponse: '',
        domaine_id: '',
        groupe_id: '',
        eco: '',
        approche: '',
        niveau: '',
        source: '',
        tag: '',
        restriction: '',
    });

    const fetchQcms = async () => {
        setIsLoading(true);
        try {
            let url;
            let config = { method: 'GET' };

            if (isSearchMode) {
                // Mode recherche avancée
                url = `${process.env.REACT_APP_HOTE}/recherche-avancee-questions/?page=${currentPage}&per_page=${itemsPerPage}&langue=${currentLangue}`;
                config = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(searchParams),
                };
            } else {
                // Mode normal
                url = `${process.env.REACT_APP_HOTE}/liste-qcm-bdd/?page=${currentPage}&per_page=${itemsPerPage}&langue=${currentLangue}`;
            }

            const response = await fetch(url, config);
            const data = await response.json();

            if (response.ok) {
                // Utiliser data.data pour les deux modes (normal et recherche)
                setQcms(data.data || data.resultats || []);
                setTotalItems(data.total || data.resultats?.length || 0);
                setHasMore(data.has_more || false);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setIsLoading(false);
        }
    };

    // Autres fonctions de récupération de données
    const fetchDomaines = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/Liste-domaine/');
            if (response.ok) {
                const data = await response.json();
                setDomaines(data);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    const fetchEcos = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/liste-eco/');
            if (response.ok) {
                const data = await response.json();
                setEcos(data);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    const fetchGroupeProcessus = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/listes-groupes-processus/');
            if (response.ok) {
                const data = await response.json();
                setGroupeProcessus(data);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    const fetchTags = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/liste-tag/');
            const data = await response.json();
            if (response.ok) {
                setTags(data);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    const sychronisation = async () => {
        try {
            await fetch(process.env.REACT_APP_HOTE + '/sync-qcm-ids/');
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    const listeQcmDefaillants = async () => {
        setIsLoadingDefaillant(true);
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/verifier-integrite-qcm/');
            const data = await response.json();
            if (response.ok) {
                setQcmsDefaillant(data.nombre_total_anomalies);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setIsLoadingDefaillant(false);
        }
    };

    // Effets
    useEffect(() => {
        if (user_id) {
            sychronisation();
            document.title = "eTrainApp | QCM";
        }
    }, [user_id]);

    useEffect(() => {
        if (user_id) {
            fetchQcms();
            fetchTags();
            // listeQcmDefaillants();
            // sychronisation();
            fetchDomaines();
            fetchEcos();
            fetchGroupeProcessus();
        }
    }, [user_id, currentPage, itemsPerPage, currentLangue]);

    // Fonctions utilitaires
    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        // listeQcmDefaillants();
    };

    const fermerNotif = () => {
        setAlert({ message: '', type: '' });
    };

    const handleRowClick = (qcm) => {
        setSelectedQcm(qcm);
    };




    const handleDeleteQcm = async () => {
        if (selectedQcmIds?.length > 0) {
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_HOTE}/supprimer-qcm/`,
                    {
                        method: "DELETE",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            selectedQcmIds: selectedQcmIds,
                            user_id: user_id,
                        }),
                    }
                );
                // const response = await fetch(process.env.REACT_APP_HOTE + `/supprimer-qcm/${selectedQcm.unicite}/${user_id}/`, {
                //     method: 'DELETE',
                // });

                const data = await response.json();
                if (response.ok) {
                    fetchQcms();
                    setSelectedQcm(null);
                    showAlert(data.message);
                } else {
                    showAlert(data.error, 'danger');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            } finally {
                setShowDeleteModal(false);
            }
        }
    };



    const [selectedQcmIds, setSelectedQcmIds] = useState([]);

    const handleCheckboxChange = (unicite) => {
        setSelectedQcmIds((prev) =>
            prev.includes(unicite) ? prev.filter((item) => item !== unicite) : [...prev, unicite]
        );
    };

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
        fetchQcms();
    };

    const toggleExpandQuestion = (qcmId) => {
        setExpandedQuestions((prevState) => ({
            ...prevState,
            [qcmId]: !prevState[qcmId],
        }));
    };

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const handleModifier = (qcm) => {
        if (qcm) {
            navigate(`/Modifier-qcm`, {
                state: { qcm_id: qcm.id, qcm_ref: qcm.unicite },
            });
        }
    };

    const handleRedirectionDefaillant = () => {
        navigate(`/Qcm-defaillants`);
    };

    // Fonctions pour l'import/export
    const handleFileChange = (e) => {
        setSelectedFile(e.target.files[0]);
    };


    // Ajoutez cet état avec les autres états
    const [importLanguage, setImportLanguage] = useState('fr');

    const handleImport = (language) => {
        setIsLoading(true);
        if (selectedFile) {
            const formData = new FormData();
            formData.append('file', selectedFile);
            formData.append('language', language);

            setIsImporting(true);
            setProgress(0);

            // Déterminer l'URL en fonction de la langue
            const url = language === 'fr'
                ? `${process.env.REACT_APP_HOTE}/import-qcm-fr/${user_id}/`
                : `${process.env.REACT_APP_HOTE}/import-qcm-en/${user_id}/`;

            const xhr = new XMLHttpRequest();
            xhr.open('POST', url, true);

            xhr.upload.addEventListener('progress', (event) => {
                if (event.lengthComputable) {
                    const percentComplete = (event.loaded / event.total) * 100;
                    setProgress(percentComplete);
                }
            });

            xhr.onload = () => {
                const data = JSON.parse(xhr.responseText);
                if (xhr.status === 200) {
                    setShowImportModal(false);
                    setAlert({
                        message: `
                    <div>
                        <h4>Importation ${language === 'fr' ? 'Française' : 'Anglaise'} réussie</h4>
                        <ul>
                            <li><strong>Message :</strong> ${data.message}</li>
                            <li><strong>Importés :</strong> ${data.imported}</li>
                            <li><strong>Mis à jour :</strong> ${data.updated}</li>
                            <li><strong>Erreurs :</strong> ${data.errors.length > 0
                                ? `<ul>${data.errors.map(error => `<li>${error}</li>`).join('')}</ul>`
                                : "Aucune"}</li>
                        </ul>
                    </div>`,
                        type: data.errors.length > 0 ? 'warning' : 'success',
                    });
                    fetchQcms();
                } else {
                    setAlert({ message: data.message, type: 'danger' });
                }
                setIsImporting(false);
                setIsLoading(false);
            };

            xhr.onerror = () => {
                setAlert({ message: 'Erreur lors de l\'importation', type: 'danger' });
                setIsImporting(false);
                setIsLoading(false);
            };

            xhr.send(formData);
        } else {
            alert("Veuillez sélectionner un fichier à importer.");
        }
    };

    const handleImportEn = (language) => {
        setIsLoading(true);
        if (selectedFile) {
            const formData = new FormData();
            formData.append('file', selectedFile);
            formData.append('language', language);

            setIsImporting(true);
            setProgress(0);

            const xhr = new XMLHttpRequest();
            xhr.open('POST', process.env.REACT_APP_HOTE + `/import-qcm-en/${user_id}/`, true);

            xhr.upload.addEventListener('progress', (event) => {
                if (event.lengthComputable) {
                    const percentComplete = (event.loaded / event.total) * 100;
                    setProgress(percentComplete);
                }
            });

            xhr.onload = () => {
                const data = JSON.parse(xhr.responseText);
                if (xhr.status === 200) {
                    setShowImportModal(false);
                    setAlert({
                        message: `
                        <div>
                            <h4>Importation Anglaise réussie</h4>
                            <ul>
                                <li><strong>Message :</strong> ${data.message}</li>
                                <li><strong>Importés :</strong> ${data.imported}</li>
                                <li><strong>Mis à jour :</strong> ${data.updated}</li>
                                <li><strong>Erreurs :</strong> ${data.errors.length > 0
                                ? `<ul>${data.errors.map(error => `<li>${error}</li>`).join('')}</ul>`
                                : "Aucune"}</li>
                            </ul>
                        </div>`,
                        type: data.errors.length > 0 ? 'warning' : 'success',
                    });
                    fetchQcms();
                } else {
                    setAlert({ message: data.message, type: 'danger' });
                }
                setIsImporting(false);
                setIsLoading(false);
            };

            xhr.onerror = () => {
                setAlert({ message: 'Erreur lors de l\'importation', type: 'danger' });
                setIsImporting(false);
                setIsLoading(false);
            };

            xhr.send(formData);
        } else {
            alert("Veuillez sélectionner un fichier à importer.");
        }
    };

    const handleExport = async () => {
        setIsLoadingBouton(true);
        try {
            const { db, tag } = exportFields;
            const url = `${process.env.REACT_APP_HOTE}/export-qcm/`;

            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/xlsx",
                },
                body: JSON.stringify({ db, tag }),
            });

            if (!response.ok) {
                throw new Error("Erreur lors de l'export des QCM");
            }

            const blob = await response.blob();
            const downloadUrl = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = downloadUrl;
            a.download = `qcm_export_${db}.xlsx`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(downloadUrl);

            setShowExportModal(false);
            showAlert("Exportation terminée avec succès !");
        } catch (error) {
            console.error("Erreur d'export:", error);
            showAlert("Une erreur est survenue lors de l'export.");
        } finally {
            setIsLoadingBouton(false);
        }
    };

    // Gestion des modals
    const handleShowDeleteModal = () => setShowDeleteModal(true);
    const handleCloseDeleteModal = () => setShowDeleteModal(false);
    const handleShowImportModal = () => setShowImportModal(true);
    const handleCloseImportModal = () => setShowImportModal(false);
    const [OuvrirViderModal, setOuvrirViderModal] = useState(false);
    const handleOuvrirViderModal = () => setOuvrirViderModal(true);
    const handleFermerViderModal = () => setOuvrirViderModal(false);

    const handleVider = async (tableAVider) => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/vider-table/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ table: tableAVider }),
            });

            if (response.ok) {
                fetchQcms();
                showAlert(`Table ${tableAVider} vidée avec succès !`);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setOuvrirViderModal(false);
        }
    };






    const [selectedTagsPourModal, setSelectedTagsPourModal] = useState([]);
    const handleAfficherModalTag = () => {
        if (selectedQcmIds?.length > 0) {
            setSelectedTagsPourModal([]);
            setAfficherModalTag(true);
        } else {
            showAlert("Veuillez sélectionner au moins un QCM", "danger");
        }
    };

    const handleAddTags = async () => {
        if (selectedTagsPourModal.length === 0) {
            showAlert("Veuillez sélectionner au moins un tag", "danger");
            return;
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/ajouter-tags-qcm/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    qcm_ids: selectedQcmIds,
                    tag_ids: selectedTagsPourModal.map(tag => tag.value),
                    user_id: user_id,
                }),
            });

            const data = await response.json();
            if (response.ok) {
                showAlert(data.message);
                fetchQcms(); // Rafraîchir la liste
                setAfficherModalTag(false);

                setSelectedQcmIds([]);
            } else {
                showAlert(data.error, "danger");
            }
        } catch (error) {
            console.error("Erreur réseau:", error);
            showAlert("Erreur lors de l'ajout des tags", "danger");
        }
    };



    const [showModalRetraitTag, setAfficherModalRetraitTag] = useState(false);
    const [selectedTagsRetirerModal, setSelectedTagsRetirerModal] = useState([]);
    const handleAfficherModalRetraitTag = () => {
        if (selectedQcmIds?.length > 0) {
            setSelectedTagsRetirerModal([]);
            setAfficherModalRetraitTag(true);
        } else {
            showAlert("Veuillez sélectionner au moins un QCM", "danger");
        }
    };

    const handleRetraitTags = async () => {
        if (selectedTagsRetirerModal.length === 0) {
            showAlert("Veuillez sélectionner au moins un tag", "danger");
            return;
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/retirer-tags-qcm/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    qcm_ids: selectedQcmIds,
                    tag_ids: selectedTagsRetirerModal.map(tag => tag.value),
                    user_id: user_id,
                }),
            });

            const data = await response.json();
            if (response.ok) {
                showAlert(data.message);
                fetchQcms();
                setAfficherModalRetraitTag(false);

                setSelectedQcmIds([]);
            } else {
                showAlert(data.error, "danger");
            }
        } catch (error) {
            console.error("Erreur réseau:", error);
            showAlert("Erreur lors de l'ajout des tags", "danger");
        }
    };

    // Vérification des accès
    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}/`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("QCM")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} titre={titre} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // Recherche avancée (non modifiée)
    const handleShowAdvancedSearchModal = () => setShowAdvancedSearchModal(true);
    const handleCloseAdvancedSearchModal = () => setShowAdvancedSearchModal(false);
    const handleAdvancedSearchChange = (e) => {
        const { name, value } = e.target;
        setAdvancedSearchFields({ ...advancedSearchFields, [name]: value });
    };
    const handleReponseChange = (selectedOptions) => {
        setAdvancedSearchFields({
            ...advancedSearchFields,
            reponse: selectedOptions ? selectedOptions.map(option => option.value) : [],
        });
    };


    const handleAdvancedSearchSubmit = async () => {
        setIsLoadingRecherche(true);
        try {
            const response = await fetch(
                `${process.env.REACT_APP_HOTE}/recherche-avancee-questions/?page=1&per_page=${itemsPerPage}`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(advancedSearchFields),
                }
            );
            const data = await response.json();

            if (response.ok) {
                setQcms(data.data || data.resultats || []);
                setTotalItems(data.total || data.resultats?.length || 0);
                setHasMore(data.has_more || false);
                setIsSearchMode(true);
                setSearchParams(advancedSearchFields);
                setCurrentPage(1); // Reset à la première page
                handleCloseAdvancedSearchModal();
                showAlert(`${data.total || data.resultats?.length || 0} QCM trouvés.`);
            }
        } catch (error) {
            console.error("Erreur lors de la recherche avancée :", error);
        } finally {
            setIsLoadingRecherche(false);
        }
    };

    const handleResetSearch = () => {
        setIsSearchMode(false);
        setSearchParams({});
        setCurrentPage(1);
        setAdvancedSearchFields({
            id: '',
            ref: '',
            question: '',
            option1: '',
            option2: '',
            option3: '',
            option4: '',
            option5: '',
            option6: '',
            reponse: '',
            domaine_id: '',
            groupe_id: '',
            eco: '',
            approche: '',
            niveau: '',
            source: '',
            tag: '',
            restriction: '',
        });
        fetchQcms(); // Recharger les QCM normaux
        showAlert("Recherche annulée - Affichage de tous les QCM");
    };


    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <div className="col-md-6">
                                <h2 className='d-flex align-items-center'><FaRegQuestionCircle size={25} className='mr-2' /> Gestion des QCMs</h2>
                                <small>Administration des QCMs.</small>
                            </div>

                            <div className="">
                                <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                    <ol className="breadcrumb custom-breadcrumb">
                                        <li className="breadcrumb-item custom-breadcrumb-item">
                                            <Link to={`/admin`}> Administration</Link>
                                        </li>
                                        <li className="breadcrumb-item custom-breadcrumb-item">
                                            <Link to={`/Liste-qcm`}> QCM</Link>
                                        </li>
                                    </ol>
                                </small>
                            </div>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`alert alert-${alert.type} row justify-content-between position-relative m-2 mt-2`}>
                            <div dangerouslySetInnerHTML={{ __html: alert.message }} />
                            <span
                                onClick={fermerNotif}
                                style={{
                                    position: 'absolute',
                                    top: '0px',
                                    right: '10px',
                                    cursor: 'pointer'
                                }}
                            >
                                <i className='fa fa-close'></i>
                            </span>
                        </div>
                    )}

                    <div className="mt-2">
                        <div className="wrapper wrapper-content animated fadeInRight">
                            <div className="d-flex flex-column justify-content-between flex-md-row mt-3 mt-md-0">
                                {/* Onglets Français/Anglais */}
                                <div className="d-flex mb-3 border-bottom">
                                    <button
                                        onClick={() => {
                                            setCurrentLangue('fr');
                                            setCurrentPage(1);
                                        }}
                                        className={`btn ${currentLangue === 'fr' ? 'btn-success' : 'btn-light'} me-2`}
                                        style={{ borderRadius: '0', borderBottom: currentLangue === 'fr' ? '2px solid #1ab394' : 'none' }}
                                    >
                                        Français
                                    </button>
                                    <button
                                        onClick={() => {
                                            setCurrentLangue('en');
                                            setCurrentPage(1);
                                        }}
                                        className={`btn ${currentLangue === 'en' ? 'btn-success' : 'btn-light'}`}
                                        style={{ borderRadius: '0', borderBottom: currentLangue === 'en' ? '2px solid #1ab394' : 'none' }}
                                    >
                                        Anglais
                                    </button>
                                </div>
                                <div className="d-flex mb-3 mt-md-0" style={{ gap: '10px' }}>
                                    <Link to={`/Ajouter-qcm`} className="btn btn-success d-flex align-items-center justify-content-centerbtn ms-2 mt-1">
                                        <FaPlus />
                                        <span className="d-none d-sm-inline ml-2">Ajouter</span>
                                    </Link>

                                    <button
                                        onClick={() => handleModifier(selectedQcm)}
                                        disabled={!selectedQcm}
                                        className={`btn d-flex align-items-center justify-content-center ms-2 mt-1 ${selectedQcm ? 'btn-success' : 'btn-default text-dark'}`}
                                    >
                                        <FaEdit />
                                        <span className="d-none d-sm-inline ml-2">Modifier</span>
                                    </button>
                                    <button
                                        onClick={handleShowDeleteModal}
                                        className={`btn d-flex align-items-center justify-content-center ms-2 mt-1 ${selectedQcmIds?.length < 1 ? 'btn-default text-dark ' : 'btn-success'}`}
                                        disabled={selectedQcmIds?.length < 1}
                                    >
                                        <FaTrash />
                                        <span className="d-none d-sm-inline ml-2">Supprimer</span>
                                    </button>

                                    <button onClick={handleShowAdvancedSearchModal} className="btn btn-success d-flex align-items-center justify-content-centerbtn ms-2 mt-1">
                                        <FaSearch />
                                        <span className="d-none d-sm-inline ml-2">Recherche</span>
                                    </button>

                                    <Dropdown as={ButtonGroup}>
                                        <Dropdown.Toggle className="btn btn-success d-flex align-items-center justify-content-centerbtn ms-2 mt-1">
                                            <FaCog /> <span className="d-none d-sm-inline ml-2">Actions</span>
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={handleAfficherModalTag}>
                                                <FaTags /> Ajouter tag
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={handleAfficherModalRetraitTag}>
                                                <FaTags /> Retirer tag
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={handleShowImportModal}>
                                                <FaFileImport /> Importer
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={() => setShowExportModal(true)}>
                                                <FaFileExport /> Exporter
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={handleOuvrirViderModal} className="text-danger">
                                                <FaTrashAlt /> Vider
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </div>

                            <div className='row'>
                                <div className="col-lg-12">
                                    <div className="ibox">
                                        <div className="ibox-content">

                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div className="me-2">
                                                    <select
                                                        value={itemsPerPage}
                                                        onChange={handleItemsPerPageChange}
                                                        className="form-select bg-default p-1"
                                                        style={{ width: 'auto', border: '1px black solid', borderRadius: '5px' }}
                                                    >
                                                        <option value={10}>10</option>
                                                        <option value={20}>20</option>
                                                        <option value={50}>50</option>
                                                    </select>
                                                </div>
                                                <div className='d-flex align-items-center'>
                                                    <div className="column-selector mr-2">
                                                        <button
                                                            style={{
                                                                width: "auto",
                                                                border: "1px black solid",
                                                                borderRadius: "5px",
                                                                backgroundColor: "transparent",
                                                            }}
                                                            className="text-dark"
                                                            onClick={() => setShowColumnSelector((prev) => !prev)}
                                                        >
                                                            Visibilité
                                                            <FaChevronDown className="ms-2" size={12} />
                                                        </button>

                                                        {showColumnSelector && (
                                                            <div
                                                                className="column-options"
                                                                style={{
                                                                    position: "absolute",
                                                                    top: "50px",
                                                                    right: "20px",
                                                                    padding: "15px",
                                                                    backgroundColor: "#f9f9f9",
                                                                    border: "1px solid #ddd",
                                                                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                                                    zIndex: 1000,
                                                                    borderRadius: "8px",
                                                                }}
                                                            >
                                                                {Object.keys(visibleColumns).map((columnKey) => (
                                                                    <div key={columnKey} className="form-check">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            id={columnKey}
                                                                            checked={visibleColumns[columnKey]}
                                                                            onClick={() => setShowColumnSelector((prev) => !prev)}
                                                                            onChange={() => {
                                                                                setVisibleColumns((prevState) => ({
                                                                                    ...prevState,
                                                                                    [columnKey]: !prevState[columnKey],
                                                                                }));
                                                                            }}
                                                                        />
                                                                        <label className="form-check-label" htmlFor={columnKey}>
                                                                            {columnLabels[columnKey] || columnKey}
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>

                                                    {isSearchMode && (
                                                        <button
                                                            onClick={handleResetSearch}
                                                            className="badge badge-warning d-flex align-items-center justify-content-centerbtn ms-2 mt-1"
                                                        >
                                                            <FaTimes />
                                                            <span className="d-none d-sm-inline ml-2">Annuler recherche</span>
                                                        </button>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="table-responsive" style={{ fontSize: '11px' }}>
                                                <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                                    <thead>
                                                        <tr>
                                                            <th></th>
                                                            {visibleColumns.id && (
                                                                <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('id')}>
                                                                    Id{sortConfig.key === 'id'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                </th>
                                                            )}
                                                            {visibleColumns.ref && (
                                                                <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('ref')}>
                                                                    Ref{sortConfig.key === 'ref'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                </th>
                                                            )}
                                                            {visibleColumns.question && (
                                                                <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('question')} style={{ width: '50%' }}>
                                                                    Question {sortConfig.key === 'question'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                </th>
                                                            )}
                                                            {visibleColumns.option1 && (
                                                                <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('option1')}>
                                                                    Option1 {sortConfig.key === 'option1'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                </th>
                                                            )}
                                                            {visibleColumns.option2 && (
                                                                <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('option2')}>
                                                                    Option2 {sortConfig.key === 'option2'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                </th>
                                                            )}
                                                            {visibleColumns.option3 && (
                                                                <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('option3')}>
                                                                    Option3 {sortConfig.key === 'option3'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                </th>
                                                            )}
                                                            {visibleColumns.option4 && (
                                                                <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('option4')}>
                                                                    Option4 {sortConfig.key === 'option4'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                </th>
                                                            )}
                                                            {visibleColumns.option5 && (
                                                                <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('option5')}>
                                                                    Option5 {sortConfig.key === 'option5'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                </th>
                                                            )}
                                                            {visibleColumns.option6 && (
                                                                <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('option6')}>
                                                                    Option6 {sortConfig.key === 'option6'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                </th>
                                                            )}
                                                            {visibleColumns.eco && (
                                                                <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('eco')}>
                                                                    Eco {sortConfig.key === 'eco'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                </th>
                                                            )}
                                                            {visibleColumns.reponse && (
                                                                <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('reponse')}>
                                                                    Reponse {sortConfig.key === 'reponse'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                </th>
                                                            )}
                                                            {visibleColumns.domaine_connaissance && (
                                                                <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('domaine_connaissance')}>
                                                                    Domaine {sortConfig.key === 'domaine_connaissance'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                </th>
                                                            )}
                                                            {visibleColumns.groupe_processus && (
                                                                <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('groupe_processus')}>
                                                                    Groupe de processus {sortConfig.key === 'groupe_processus'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                </th>
                                                            )}
                                                            {visibleColumns.approche && (
                                                                <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('approche')}>
                                                                    Approche {sortConfig.key === 'approche'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                </th>
                                                            )}
                                                            {visibleColumns.niveau && (
                                                                <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('niveau')}>
                                                                    Niveau {sortConfig.key === 'niveau'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                </th>
                                                            )}
                                                            {visibleColumns.source && (
                                                                <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('source')}>
                                                                    Source {sortConfig.key === 'source'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                </th>
                                                            )}
                                                            {visibleColumns.tag && (
                                                                <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('tag')}>
                                                                    Tag {sortConfig.key === 'tag'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                </th>
                                                            )}
                                                            {visibleColumns.situation && (
                                                                <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('situation')}>
                                                                    Mise en situation {sortConfig.key === 'situation'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}
                                                                </th>
                                                            )}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {!isLoading ? (
                                                            qcms.map((qcm) => (
                                                                <tr
                                                                    key={qcm.id}
                                                                    className={`bg-white ${selectedQcm && selectedQcm.id === qcm.id ? 'bg-success text-white' : ''}`}
                                                                    onClick={() => handleRowClick(qcm)}
                                                                    style={{ cursor: 'pointer' }}
                                                                >
                                                                    <td>
                                                                        <input
                                                                            type="checkbox"
                                                                            className="i-checks"
                                                                            name="input[]"
                                                                            checked={selectedQcmIds?.includes(qcm.unicite)}
                                                                            onChange={() => handleCheckboxChange(qcm.unicite)}
                                                                            style={{ cursor: 'pointer' }}
                                                                        />
                                                                    </td>
                                                                    {visibleColumns.id &&
                                                                        <td>
                                                                            {qcm.id}
                                                                            <div className='lesInfos'>
                                                                                <small
                                                                                    id={`question-${qcm.id}`}
                                                                                    ref={(el) => (questionRefs.current[qcm.id] = el)}
                                                                                    className={`question-text ${expandedQuestions[qcm.id] ? 'expanded' : ''}`}
                                                                                    style={{
                                                                                        maxHeight: expandedQuestions[qcm.id] ? 'none' : '3em',
                                                                                        overflow: 'hidden',
                                                                                        whiteSpace: 'pre-wrap',
                                                                                    }}
                                                                                > <strong>Question</strong> :&nbsp;
                                                                                    {qcm.question ? (
                                                                                        <span dangerouslySetInnerHTML={{ __html: qcm.question }}></span>
                                                                                    ) : (
                                                                                        <em>Non défini</em>
                                                                                    )}
                                                                                </small>
                                                                                {qcm.question && questionOverflows[qcm.id] && (
                                                                                    <button
                                                                                        className='text-success'
                                                                                        onClick={(e) => {
                                                                                            e.stopPropagation();
                                                                                            toggleExpandQuestion(qcm.id);
                                                                                        }}
                                                                                        style={{
                                                                                            background: 'none',
                                                                                            border: 'none',
                                                                                            color: 'black',
                                                                                            cursor: 'pointer',
                                                                                            padding: 0,
                                                                                        }}
                                                                                    >
                                                                                        {expandedQuestions[qcm.id] ? 'Voir moins' : 'Voir plus...'}
                                                                                    </button>
                                                                                )}<br />
                                                                                <small> <strong>Domaine</strong> : {qcm.domaine_id}</small><br />
                                                                                <small> <strong>Groupe de processus</strong> : {qcm.groupe_id}</small><br />
                                                                                <small> <strong>Approche</strong> : {qcm.approche}</small><br />
                                                                                <small>
                                                                                    <strong>Reponse</strong> : {' '}
                                                                                    {(() => {
                                                                                        // Si c'est une question par correspondance (reponse est un objet)
                                                                                        if (qcm.type_question === 'correspondance' && typeof qcm.reponse === 'object' && !Array.isArray(qcm.reponse)) {
                                                                                            const pairs = Object.entries(qcm.reponse);
                                                                                            if (pairs.length === 0) return 'Aucune correspondance';
                                                                                            return pairs.map(([left, right], index) => (
                                                                                                <span key={index}>
                                                                                                    {left} → {right}
                                                                                                    {index < pairs.length - 1 ? ', ' : ''}
                                                                                                </span>
                                                                                            ));
                                                                                        }
                                                                                        // Si c'est une question par défaut (reponse est un tableau)
                                                                                        else if (Array.isArray(qcm.reponse)) {
                                                                                            return qcm.reponse.join(', ');
                                                                                        }
                                                                                        // Si c'est une chaîne ou autre
                                                                                        else {
                                                                                            return typeof qcm.reponse === 'string' ? qcm.reponse : JSON.stringify(qcm.reponse);
                                                                                        }
                                                                                    })()}
                                                                                </small><br />
                                                                                <small> <strong>Niveau</strong> : {qcm.niveau}</small><br />
                                                                                <small> <strong>Source</strong> : {qcm.source}</small><br />
                                                                                <small> <strong>Tag</strong> : {qcm.tag}</small><br />
                                                                                <small> <strong>Mise en situation</strong> : {qcm.situation_id || 'Aucune'}</small>
                                                                            </div>
                                                                        </td>
                                                                    }
                                                                    {visibleColumns.ref &&
                                                                        <td className="d-none d-md-table-cell">
                                                                            {qcm.ref}
                                                                        </td>
                                                                    }
                                                                    {visibleColumns.question &&
                                                                        <td className="d-none d-md-table-cell" style={{
                                                                            minWidth: '430px',
                                                                            maxWidth: '600px',
                                                                            wordBreak: 'break-word',
                                                                            whiteSpace: 'pre-wrap'
                                                                        }}>
                                                                            <div
                                                                                id={`question-${qcm.id}`}
                                                                                ref={(el) => {
                                                                                    questionRefs.current[qcm.id] = el;
                                                                                    if (el) {
                                                                                        questionOverflows[qcm.id] = el.scrollHeight > el.clientHeight;
                                                                                    }
                                                                                }}
                                                                                className={`question-text ${expandedQuestions[qcm.id] ? 'expanded' : ''}`}
                                                                                style={{
                                                                                    maxHeight: expandedQuestions[qcm.id] ? 'none' : '4em',
                                                                                    overflow: 'hidden',
                                                                                    whiteSpace: 'pre-wrap',
                                                                                    transition: 'max-height 0.3s ease-in-out',
                                                                                }}
                                                                            >
                                                                                {qcm.question ? (
                                                                                    <span dangerouslySetInnerHTML={{ __html: qcm.question }}></span>
                                                                                ) : (
                                                                                    <em>Non défini</em>
                                                                                )}
                                                                            </div>
                                                                        </td>
                                                                    }
                                                                    {visibleColumns.option1 &&
                                                                        <td className="d-none d-md-table-cell" title={qcm?.option1}>
                                                                            {qcm?.option1?.length > 20 ? qcm?.option1.substring(0, 20) + "..." : qcm?.option1}
                                                                        </td>
                                                                    }
                                                                    {visibleColumns.option2 &&
                                                                        <td className="d-none d-md-table-cell" title={qcm?.option2}>
                                                                            {qcm?.option2?.length > 20 ? qcm?.option2.substring(0, 20) + "..." : qcm?.option2}
                                                                        </td>
                                                                    }
                                                                    {visibleColumns.option3 &&
                                                                        <td className="d-none d-md-table-cell" title={qcm?.option3}>
                                                                            {qcm?.option3?.length > 20 ? qcm?.option3.substring(0, 20) + "..." : qcm?.option3}
                                                                        </td>
                                                                    }
                                                                    {visibleColumns.option4 &&
                                                                        <td className="d-none d-md-table-cell" title={qcm?.option4}>
                                                                            {qcm?.option4?.length > 20 ? qcm?.option4.substring(0, 20) + "..." : qcm?.option4}
                                                                        </td>
                                                                    }
                                                                    {visibleColumns.option5 &&
                                                                        <td className="d-none d-md-table-cell" title={qcm?.option5}>
                                                                            {qcm?.option5?.length > 20 ? qcm?.option5.substring(0, 20) + "..." : qcm?.option5}
                                                                        </td>
                                                                    }
                                                                    {visibleColumns.option6 &&
                                                                        <td className="d-none d-md-table-cell" title={qcm?.option6}>
                                                                            {qcm?.option6?.length > 20 ? qcm?.option6.substring(0, 20) + "..." : qcm?.option6}
                                                                        </td>
                                                                    }
                                                                    {visibleColumns.reponse &&
                                                                        <td className="d-none d-md-table-cell">
                                                                            {(() => {
                                                                                // Si c'est une question par correspondance (reponse est un objet)
                                                                                if (qcm.type_question === 'correspondance' && typeof qcm.reponse === 'object' && !Array.isArray(qcm.reponse)) {
                                                                                    const pairs = Object.entries(qcm.reponse);
                                                                                    if (pairs.length === 0) return 'Aucune correspondance';
                                                                                    return pairs.map(([left, right], index) => (
                                                                                        <span key={index}>
                                                                                            {left} → {right}
                                                                                            {index < pairs.length - 1 ? ', ' : ''}
                                                                                        </span>
                                                                                    ));
                                                                                }
                                                                                // Si c'est une question par défaut (reponse est un tableau)
                                                                                else if (Array.isArray(qcm.reponse)) {
                                                                                    return qcm.reponse.join(', ');
                                                                                }
                                                                                // Si c'est une chaîne ou autre
                                                                                else {
                                                                                    return typeof qcm.reponse === 'string' ? qcm.reponse : JSON.stringify(qcm.reponse);
                                                                                }
                                                                            })()}
                                                                        </td>
                                                                    }
                                                                    {visibleColumns.eco &&
                                                                        <td className="d-none d-md-table-cell">{qcm.eco}</td>
                                                                    }
                                                                    {visibleColumns.domaine_connaissance && <td className="d-none d-md-table-cell">{qcm.domaine_id !== 'non défini' ? qcm.domaine_id : '-'}</td>}
                                                                    {visibleColumns.groupe_processus && <td className="d-none d-md-table-cell">{qcm.groupe_id !== 'non défini' ? qcm.groupe_id : '-'}</td>}
                                                                    {visibleColumns.approche && <td className="d-none d-md-table-cell">{qcm.approche}</td>}
                                                                    {visibleColumns.niveau && <td className="d-none d-md-table-cell">{qcm.niveau}</td>}
                                                                    {visibleColumns.source && <td className="d-none d-md-table-cell">{qcm.source}</td>}
                                                                    {visibleColumns.tag &&
                                                                        <td className="d-none d-md-table-cell">
                                                                            {(() => {
                                                                                let tagsArray = [];

                                                                                if (Array.isArray(qcm.tag)) {
                                                                                    tagsArray = qcm.tag;
                                                                                } else if (typeof qcm.tag === "string") {
                                                                                    try {
                                                                                        tagsArray = JSON.parse(qcm.tag);
                                                                                    } catch (error) {
                                                                                        tagsArray = qcm.tag.replace(/[\[\]']/g, '')
                                                                                            .trim()
                                                                                            .split(',')
                                                                                            .map(item => item.trim());
                                                                                    }
                                                                                }

                                                                                if (tagsArray.length === 0) {
                                                                                    return <span className="badge badge-secondary">Aucun</span>;
                                                                                }

                                                                                return (
                                                                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', maxWidth: '200px' }}>
                                                                                        {tagsArray.map((tag, index) => (
                                                                                            <span
                                                                                                key={index}
                                                                                                className="badge badge-success"
                                                                                                style={{ fontSize: '11px' }}
                                                                                            >
                                                                                                {tag}
                                                                                            </span>
                                                                                        ))}
                                                                                    </div>
                                                                                );
                                                                            })()}
                                                                        </td>
                                                                    }
                                                                    {visibleColumns.situation &&
                                                                        <td className="d-none d-md-table-cell">
                                                                            {qcm.situation_id || 'Aucune'}
                                                                        </td>
                                                                    }
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="20">
                                                                    <div className="mt-3 d-flex justify-content-center align-items-center" style={{ height: '100%', width: '100%' }}>
                                                                        <div className="d-flex justify-content-center align-items-center">
                                                                            <div className="spiner-example">
                                                                                <div className="sk-spinner sk-spinner-wave">
                                                                                    <div className="sk-rect1 mr-1"></div>
                                                                                    <div className="sk-rect2 mr-1"></div>
                                                                                    <div className="sk-rect3 mr-1"></div>
                                                                                    <div className="sk-rect4 mr-1"></div>
                                                                                    <div className="sk-rect5"></div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>

                                            {/* Pagination Controls */}
                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <div className="dataTables_info" role="status" aria-live="polite">
                                                    {qcms.length === 0
                                                        ? "Aucun élément à afficher"
                                                        : `Élément ${(currentPage - 1) * itemsPerPage + 1} à ${Math.min(currentPage * itemsPerPage, totalItems)} sur ${totalItems}`}
                                                </div>
                                                <div>
                                                    <button
                                                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === 1}
                                                    >
                                                        <FaArrowLeft />
                                                    </button>

                                                    {(() => {
                                                        const pagesToShow = 5;
                                                        let startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
                                                        let endPage = Math.min(Math.ceil(totalItems / itemsPerPage), startPage + pagesToShow - 1);

                                                        if (endPage - startPage < pagesToShow - 1) {
                                                            startPage = Math.max(1, endPage - pagesToShow + 1);
                                                        }

                                                        const pageButtons = [];

                                                        for (let i = startPage; i <= endPage; i++) {
                                                            pageButtons.push(
                                                                <button
                                                                    key={i}
                                                                    onClick={() => setCurrentPage(i)}
                                                                    className={`btn ${currentPage === i ? 'btn-default' : 'btn-light'} mx-1`}
                                                                >
                                                                    {i}
                                                                </button>
                                                            );
                                                        }

                                                        return pageButtons;
                                                    })()}

                                                    <button
                                                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, Math.ceil(totalItems / itemsPerPage)))}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === Math.ceil(totalItems / itemsPerPage) || !hasMore}
                                                    >
                                                        <FaArrowRight />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Modals */}
                            <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                                <Modal.Header>
                                    <Modal.Title>Confirmer la Suppression</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    Êtes-vous sûr de vouloir supprimer le QCM ?
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleCloseDeleteModal}>
                                        Annuler
                                    </Button>
                                    <Button variant="success" onClick={handleDeleteQcm}>
                                        Supprimer
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            <Modal show={showImportModal} onHide={handleCloseImportModal}>
                                <Modal.Header>
                                    <Modal.Title>Importation</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Form.Group controlId="formLangueImport" className="mb-3">
                                        <Form.Label><strong>Langue d'importation</strong></Form.Label>
                                        <Form.Select
                                            value={importLanguage}
                                            onChange={(e) => setImportLanguage(e.target.value)}
                                            className="custom-select"
                                        >
                                            <option value="fr">Français</option>
                                            <option value="en">Anglais</option>
                                        </Form.Select>
                                    </Form.Group>

                                    <Form.Group controlId="formFile" className="mt-3">
                                        <Form.Label>Choisissez un fichier à importer</Form.Label>
                                        <Form.Control type="file" onChange={handleFileChange} />
                                    </Form.Group>

                                    {isImporting && (
                                        <div className="mt-3">
                                            <ProgressBar now={progress} label={`${Math.round(progress)}%`} />
                                        </div>
                                    )}
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleCloseImportModal}>
                                        Annuler
                                    </Button>

                                    {!isLoading ? (
                                        <Button
                                            variant="success"
                                            onClick={() => handleImport(importLanguage)}
                                            disabled={!selectedFile || isImporting}
                                        >
                                            {isImporting ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" />
                                                    Import en cours...
                                                </>
                                            ) : (
                                                `Importer en ${importLanguage === 'fr' ? 'Français' : 'Anglais'}`
                                            )}
                                        </Button>
                                    ) : (
                                        <Button variant="success" disabled>
                                            <span className="spinner-border spinner-border-sm me-2" />
                                            Chargement...
                                        </Button>
                                    )}
                                </Modal.Footer>
                            </Modal>

                            <Modal show={showExportModal} onHide={() => setShowExportModal(false)}>
                                <Modal.Header>
                                    <Modal.Title>Exporter les QCM</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Form>
                                        <Form.Group controlId="formLangue">
                                            <Form.Label><strong>Langue</strong></Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="db"
                                                value={exportFields.db}
                                                onChange={(e) => setExportFields({ ...exportFields, [e.target.name]: e.target.value })}
                                            >
                                                <option value="fr">Français</option>
                                                <option value="en">Anglais</option>
                                            </Form.Control>
                                        </Form.Group>

                                        <Form.Group controlId="formTag" className="mt-3">
                                            <Form.Label><strong>Tag</strong></Form.Label>
                                            <input
                                                list="tags-list"
                                                className="form-control"
                                                name="tag"
                                                id="tag"
                                                placeholder="Filtrer par tag (optionnel)"
                                                value={exportFields.tag}
                                                onChange={(e) => setExportFields({ ...exportFields, [e.target.name]: e.target.value })}
                                            />
                                            <datalist id="tags-list">
                                                {tags.map((tag) => (
                                                    <option key={tag.id} value={tag.titre} />
                                                ))}
                                            </datalist>
                                        </Form.Group>
                                    </Form>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={() => setShowExportModal(false)}>
                                        Annuler
                                    </Button>

                                    {isLoadingBouton ? (
                                        <button className="btn btn-success mr-2" disabled>
                                            <i className="fa fa-spinner fa-spin mr-1"></i>
                                            <span className="d-none d-sm-inline">
                                                Chargement...
                                            </span>
                                        </button>
                                    ) : (
                                        <Button variant="success" onClick={handleExport}>
                                            Exporter
                                        </Button>
                                    )}
                                </Modal.Footer>
                            </Modal>

                            {/* Modal de recherche avancée (non modifié) */}

                            <Modal show={showAdvancedSearchModal} onHide={handleCloseAdvancedSearchModal} size="lg">
                                <Modal.Header className="bg-light">
                                    <Modal.Title className="text-primary">
                                        <FaSearch className="mr-2" />
                                        Recherche Avancée
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body className="p-0">
                                    <div className="row m-0">
                                        {/* Colonne de gauche */}
                                        <div className="col-md-6 p-3 border-end">
                                            {/* Section Identification */}
                                            <div className="mb-4">
                                                <h6 className="text-muted border-bottom pb-2">Identification</h6>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>ID</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="id"
                                                        value={advancedSearchFields.id}
                                                        onChange={handleAdvancedSearchChange}
                                                        size="sm"
                                                    />
                                                </Form.Group>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Référence</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="ref"
                                                        value={advancedSearchFields.ref}
                                                        onChange={handleAdvancedSearchChange}
                                                        size="sm"
                                                    />
                                                </Form.Group>
                                            </div>

                                            {/* Section Question/Réponses */}
                                            <div className="mb-4">
                                                <h6 className="text-muted border-bottom pb-2">Question/Réponses</h6>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Question</Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={2}
                                                        name="question"
                                                        value={advancedSearchFields.question}
                                                        onChange={handleAdvancedSearchChange}
                                                        size="sm"
                                                    />
                                                </Form.Group>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Réponse</Form.Label>
                                                    <Select
                                                        options={options}
                                                        isMulti
                                                        value={options.filter(option => advancedSearchFields.reponse.includes(option.value))}
                                                        onChange={handleReponseChange}
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                    />
                                                </Form.Group>
                                            </div>

                                            {/* Section Options */}
                                            <div className="mb-4">
                                                <h6 className="text-muted border-bottom pb-2">Options</h6>
                                                <div className="row">
                                                    {[1, 2, 3, 4, 5, 6].map(num => (
                                                        <div className="col-6 mb-2" key={`option${num}`}>
                                                            <Form.Label>Option {num}</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name={`option${num}`}
                                                                value={advancedSearchFields[`option${num}`]}
                                                                onChange={handleAdvancedSearchChange}
                                                                size="sm"
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Colonne de droite */}
                                        <div className="col-md-6 p-3">
                                            {/* Section Métadonnées */}
                                            <div className="mb-4">
                                                <h6 className="text-muted border-bottom pb-2">Métadonnées</h6>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Domaine</Form.Label>
                                                    <Form.Select
                                                        className='custom-select'
                                                        name="domaine_id"
                                                        value={advancedSearchFields.domaine_id}
                                                        onChange={handleAdvancedSearchChange}
                                                        size="sm"
                                                    >
                                                        <option value="">Tous les domaines</option>
                                                        {domaines.map(domaine => (
                                                            <option key={domaine.id} value={domaine.ordre}>
                                                                {domaine.titre}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                </Form.Group>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Groupe de processus</Form.Label>
                                                    <Form.Select
                                                        className='custom-select'
                                                        name="groupe_id"
                                                        value={advancedSearchFields.groupe_id}
                                                        onChange={handleAdvancedSearchChange}
                                                        size="sm"
                                                    >
                                                        <option value="">Tous les groupes</option>
                                                        {groupeprocessus.map(groupe => (
                                                            <option key={groupe.id} value={groupe.ordre}>
                                                                {groupe.titre_fr}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                </Form.Group>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Eco</Form.Label>
                                                    <Form.Select
                                                        className='custom-select'
                                                        name="eco"
                                                        value={advancedSearchFields.eco}
                                                        onChange={handleAdvancedSearchChange}
                                                        size="sm"
                                                    >
                                                        <option value="">Tous les écos</option>
                                                        {ecos.map(eco => (
                                                            <option key={eco.id} value={eco.ordre}>
                                                                {eco.titre}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                </Form.Group>
                                            </div>

                                            {/* Section Classification */}
                                            <div className="mb-4">
                                                <h6 className="text-muted border-bottom pb-2">Classification</h6>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Approche</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="approche"
                                                        value={advancedSearchFields.approche}
                                                        onChange={handleAdvancedSearchChange}
                                                        size="sm"
                                                    />
                                                </Form.Group>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Niveau</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="niveau"
                                                        value={advancedSearchFields.niveau}
                                                        onChange={handleAdvancedSearchChange}
                                                        size="sm"
                                                    />
                                                </Form.Group>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Source</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="source"
                                                        value={advancedSearchFields.source}
                                                        onChange={handleAdvancedSearchChange}
                                                        size="sm"
                                                    />
                                                </Form.Group>
                                            </div>

                                            {/* Section Tags/Restrictions */}
                                            <div>
                                                <h6 className="text-muted border-bottom pb-2">Filtres supplémentaires</h6>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Tags</Form.Label>
                                                    <input
                                                        list="tags-list"
                                                        className="form-control form-control-sm"
                                                        name="tag"
                                                        value={advancedSearchFields.tag}
                                                        onChange={handleAdvancedSearchChange}
                                                    />
                                                    <datalist id="tags-list">
                                                        {tags.map(tag => <option key={tag.id} value={tag.titre} />)}
                                                    </datalist>
                                                </Form.Group>
                                                <Form.Group>
                                                    <Form.Label>Restriction</Form.Label>
                                                    <input
                                                        list="restriction-list"
                                                        className="form-control form-control-sm"
                                                        name="restriction"
                                                        value={advancedSearchFields.restriction}
                                                        onChange={handleAdvancedSearchChange}
                                                    />
                                                    <datalist id="restriction-list">
                                                        {restrictions.map((restriction, i) => (
                                                            <option key={i} value={restriction.label} />
                                                        ))}
                                                    </datalist>
                                                </Form.Group>
                                            </div>
                                        </div>
                                    </div>
                                </Modal.Body>
                                <Modal.Footer className="bg-light">
                                    <Button variant="outline-secondary" onClick={handleCloseAdvancedSearchModal}>
                                        Annuler
                                    </Button>
                                    <Button
                                        variant="success"
                                        onClick={handleAdvancedSearchSubmit}
                                        disabled={isLoadingRecherche}
                                    >
                                        {isLoadingRecherche ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                                                Recherche en cours...
                                            </>
                                        ) : (
                                            <>
                                                <FaSearch className="mr-1" />
                                                Rechercher
                                            </>
                                        )}
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            <Modal show={OuvrirViderModal} onHide={handleFermerViderModal}>
                                <Modal.Header>
                                    <Modal.Title>Confirmer la Suppression</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <p>Êtes-vous sûr de vouloir vider la table des QCMs ?</p>
                                    <p><strong>NB :</strong> Vous pouvez choisir de vider une ou les deux tables.</p>
                                    <Form>
                                        <Form.Check
                                            type="radio"
                                            label="Vider uniquement la table QCM Francaise"
                                            name="viderOption"
                                            value="Fr"
                                            checked={tableAVider === "Fr"}
                                            onChange={(e) => setTableAVider(e.target.value)}
                                        />
                                        <Form.Check
                                            type="radio"
                                            label="Vider uniquement la table QCM Anglaise"
                                            name="viderOption"
                                            value="Ang"
                                            checked={tableAVider === "Ang"}
                                            onChange={(e) => setTableAVider(e.target.value)}
                                        />
                                        <Form.Check
                                            type="radio"
                                            label="Vider les deux tables"
                                            name="viderOption"
                                            value="toutes"
                                            checked={tableAVider === "toutes"}
                                            onChange={(e) => setTableAVider(e.target.value)}
                                        />
                                    </Form>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleFermerViderModal}>
                                        Annuler
                                    </Button>
                                    <Button variant="success" onClick={() => handleVider(tableAVider)}>
                                        Confirmer
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            <Modal show={showModalTag} onHide={() => setAfficherModalTag(false)}>
                                <Modal.Header>
                                    <Modal.Title>Ajouter des tags aux QCM sélectionnés</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Form.Group>
                                        <Form.Label>Sélectionnez les tags à ajouter</Form.Label>
                                        <Select
                                            options={tags.map(tag => ({
                                                value: tag.id,
                                                label: tag.titre,
                                            }))}
                                            isMulti
                                            value={selectedTagsPourModal}
                                            onChange={setSelectedTagsPourModal}
                                            placeholder="Sélectionnez des tags..."
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            styles={{
                                                multiValue: (base) => ({
                                                    ...base,
                                                    backgroundColor: "#0b5ed7",
                                                    color: "white",
                                                    borderRadius: "5px",
                                                }),
                                                multiValueLabel: (base) => ({
                                                    ...base,
                                                    color: "white",
                                                }),
                                                multiValueRemove: (base) => ({
                                                    ...base,
                                                    color: "white",
                                                    ':hover': {
                                                        backgroundColor: "#0b5ed7",
                                                        color: "white",
                                                    }
                                                })
                                            }}
                                        />
                                    </Form.Group>
                                    <div className="mt-3">
                                        <strong>QCMs sélectionnés :</strong> {selectedQcmIds?.length}
                                    </div>
                                    <div className="mt-2">
                                        <small className="text-muted">
                                            Les tags sélectionnés seront ajoutés à tous les QCMs sélectionnés
                                        </small>
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={() => setAfficherModalTag(false)}>
                                        Annuler
                                    </Button>
                                    <Button
                                        variant="success"
                                        onClick={handleAddTags}
                                        disabled={selectedTagsPourModal.length === 0}
                                    >
                                        Confirmer l'ajout
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            <Modal show={showModalRetraitTag} onHide={() => setAfficherModalRetraitTag(false)}>
                                <Modal.Header>
                                    <Modal.Title>Retirer les tags des QCM sélectionnés</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Form.Group>
                                        <Form.Label>Sélectionnez les tags à retirer</Form.Label>
                                        <Select
                                            options={tags.map(tag => ({
                                                value: tag.id,
                                                label: tag.titre,
                                            }))}
                                            isMulti
                                            value={selectedTagsRetirerModal}
                                            onChange={setSelectedTagsRetirerModal}
                                            placeholder="Sélectionnez des tags..."
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            styles={{
                                                multiValue: (base) => ({
                                                    ...base,
                                                    backgroundColor: "#0b5ed7",
                                                    color: "white",
                                                    borderRadius: "5px",
                                                }),
                                                multiValueLabel: (base) => ({
                                                    ...base,
                                                    color: "white",
                                                }),
                                                multiValueRemove: (base) => ({
                                                    ...base,
                                                    color: "white",
                                                    ':hover': {
                                                        backgroundColor: "#0b5ed7",
                                                        color: "white",
                                                    }
                                                })
                                            }}
                                        />
                                    </Form.Group>
                                    <div className="mt-3">
                                        <strong>QCMs sélectionnés :</strong> {selectedQcmIds?.length}
                                    </div>
                                    <div className="mt-2">
                                        <small className="text-muted">
                                            Les tags sélectionnés seront retirés de tous les QCMs sélectionnés
                                        </small>
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={() => setAfficherModalRetraitTag(false)}>
                                        Annuler
                                    </Button>
                                    <Button
                                        variant="success"
                                        onClick={handleRetraitTags}
                                        disabled={selectedTagsRetirerModal.length === 0}
                                    >
                                        Confirmer le retrait
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Liste_qcm;